import React from 'react'
// import { Link } from 'react-router-dom'

function UiServicesDetails() {
  return (
    <div>
      <div className="services-details-area default-padding">
        <div className="cotnainer">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="site-heading text-center">
                <h4 className="sub-title">Shopify Development</h4>
                <h1 className="title">Shopify Development That Delivers Results – Every Time</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="services-details-items">
            <div className="row">
              <div className="col-xl-12 services-single-content">
                <div className="thumb mb-50">
                  <img className="w-100" src="static/img/ui/21.webp" alt="Thumb" title='Application Development' />
                </div>
                <p>
                  As a leading <strong>Shopify development company,</strong> we specialize in creating stores that are both visually stunning and revenue-driven. Our skilled Shopify development services take the hassle out of developing a high-converting, beautiful e-commerce store to transform visitors into raving customers. Whether you are building your store from the ground up or simply upgrading an existing site, we offer tailored solutions to fit your brand and goals. From custom theme development to seamless integrations and performance enhancements - we have everything you need to grow, scale, and succeed on Shopify.

                </p>
                <h2>Your Business, Our Shopify Expertise</h2>
                <p>
                  <strong>Shopify Store Build & Customizationt:</strong> We are experts who build responsive, user-friendly Shopify stores specifically for your brand. From theme selection to advanced UI/UX customization, we make sure your store is visually stunning and conversion-friendly on every device.  If you're looking for professional e-commerce website designing, Microcode Software offers solutions that align with your brand goals.
                </p>
                <p>
                  <strong> Custom Shopify App Development:</strong> Do you need some unique features? Our developers design and build custom Shopify apps that add functionality, automate workflows, and improve user experience - your business will shine in a crowded marketplace.
                </p>
                <p><strong>Smooth Migration to Shopify:</strong>  If you want to migrate from another platform such as WooCommerce, Magento, BigCommerce or anything else to Shopify, we offer a seamless and secure migration service. From products customers and orders, we ensure your data is secure with 0 interruptions to your business.
                </p>
                <p><strong>Third-party Integrations Integration:</strong>  Your store can run smoothly with all of your favorite 3rd party integrated with important applications such as CRMs, payment gateways, shipping systems, inventory, email marketing and much more.  We make sure all connections are seamless and your business can run without interruptions.
                </p>
                <p><strong>Shopify Theme Development & Customization:</strong>   As an experienced e-commerce website designing company, we prioritize functionality and aesthetics equally and customize your current theme or we can build you a custom theme from scratch, our design group will create stunning themes, with thoughtful UI/UX and emphasizes conversion, are optimized for mobile, and can capitalize on your brand identity.
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="services-content bg-gray default-padding">
        <div className="container">
          <div className="about-style-one-items">
            <div className="row align-items-center">

              <div className="col-xl-7 col-lg-6 pl-50 pl-md-15 pl-xs-15">
                <div className="about-style-one-info">
                  <div className="content">
                    <h2 className="title">
                      Shopify That Fits Your Business
                    </h2>
                    <p>
                    We are not just a Shopify development company, we are a partner in helping you build a successful online store. With customizations, integrations and improvements to performance, we provide you with unique Shopify solutions to help you grow and achieve your goals.

                    </p>
                    <a class="btn btn-md circle btn-gradient animation mb-20 mb-lg-0" href="/contact" data-discover="true">Contact Us</a>
                  </div>
                </div>
              </div>
              <div className="col-xl-5 col-lg-6">
                <div className="thumb-style-one">
                  <img src="static/img/ui/2.webp" alt="Img Not Found" title='Application Development' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='services-details-area default-padding'>
        <div className='container'>
          <div className="process-style-one-items mt-50">
            <div className="choose-us-one-thumb">
              <div className="content">
                <div className="left-info">
                  <h2 className="title">
                    Crafting Your Store, Step by Step
                  </h2>
                </div>
                <div className="process-style-one">
                  <div className="process-style-one-item">
                    <span>01</span>
                    <h4>Explore & Plan</h4>
                    <p>
                      We review your brand and goals to build your unique Shopify playbook.
                    </p>
                  </div>
                  <div className="process-style-one-item">
                    <span>02</span>
                    <h4>Design, Develop & Connect</h4>
                    <p>
                      We create a beautiful, fast-performing store designed for your needs.
                    </p>
                  </div>
                  <div className="process-style-one-item">
                    <span>03</span>
                    <h4>Test, Launch & Improve</h4>
                    <p>
                      We ensure that all systems support your growth after launch.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default UiServicesDetails
